var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import omitProps from '@hocs/omit-props';
import ladaPrefix from '@lada/prefix';
import styleTransformArrayToText from './styleTransformArrayToText';

// Styles (mostly) extracted from 'react-primitives'
// source: https://github.com/lelandrichardson/react-primitives/blob/338add9f4fbbdc5bf12fb4873f143e52af3efde6/src/web/StyleSheet/initialStyles.js#L7
var styles = {
  alignItems: 'stretch',
  borderStyle: 'solid',
  borderWidth: 0,
  boxSizing: 'border-box',
  display: 'flex',
  flexBasis: 'auto',
  flexDirection: 'column',
  flexShrink: 0,
  // fix flexbox bugs
  minHeight: 0,
  minWidth: 0
};

var Layout = function Layout(_ref) {
  var children = _ref.children,
      onRef = _ref.onRef,
      tag = _ref.tag,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['children', 'onRef', 'tag', 'style']);

  var lineHeight = style.lineHeight,
      transform = style.transform,
      restOfStyle = _objectWithoutProperties(style, ['lineHeight', 'transform']);

  var elementProps = _extends({
    children: children,
    style: ladaPrefix(_extends({}, styles, restOfStyle, lineHeight && {
      lineHeight: lineHeight + 'px'
    }, transform && {
      transform: styleTransformArrayToText(transform)
    }))
  }, props);

  switch (tag) {
    case 'label':
      var htmlFor = elementProps.htmlFor,
          restOfElementProps = _objectWithoutProperties(elementProps, ['htmlFor']);

      return React.createElement('label', _extends({ htmlFor: htmlFor, ref: onRef }, restOfElementProps));

    default:
      return React.createElement('div', _extends({ ref: onRef }, elementProps));
  }
};

export default omitProps('width', 'height', 'onResize')(Layout);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@primitives/layout/build/web/Layout.js
// module id = 197
// module chunks = 0